import { mapValues } from 'lodash';
import * as lexicalHelpers from 'modules/Lexical/helpers';
import * as Models from 'models';
import { isCallToAction, isTextComponent } from 'utils/entityType';

export function removeMissingAbbreviations(
  documents: Models.CombinedDocuments,
  textAbbreviationDocuments: Models.TextAbbreviationDocumentsArray,
): Models.CombinedDocuments {
  return mapValues(documents, (document) => {
    if ((isTextComponent(document) || isCallToAction(document))) {
      return lexicalHelpers.removeAbbreviationsOnComponentIfNotPresent(document, textAbbreviationDocuments);
    }

    return document;
  });
}
